import React from 'react';
import Icon from '../../../components/AppIcon';
import ReactMarkdown from 'react-markdown';

const ChatMessage = ({ message, isUser, timestamp }) => {
  const formatTime = (date) => {
    if (!date) return '';
    return new Date(date)?.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  };

  return (
    <div className={`flex ${isUser ? 'justify-end' : 'justify-start'} mb-4`}>
      <div className={`max-w-xs lg:max-w-md xl:max-w-lg ${isUser ? 'order-2' : 'order-1'}`}>
        {/* Avatar */}
        <div
          className={`flex items-end space-x-2 ${
            isUser ? 'flex-row-reverse space-x-reverse' : 'flex-row'
          }`}
        >
          <div
            className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center ${
              isUser ? 'bg-blue-600' : 'bg-emerald-600'
            }`}
          >
            <Icon
              name={isUser ? 'User' : 'Bot'}
              size={16}
              color="white"
              strokeWidth={2}
            />
          </div>

          {/* Message Bubble */}
          <div
            className={`px-4 py-3 rounded-2xl shadow-soft ${
              isUser
                ? 'bg-blue-600 text-white rounded-br-md'
                : 'bg-white border border-border text-text-primary rounded-bl-md'
            }`}
          >
            <div
              className={`prose prose-sm max-w-none ${
                isUser ? 'text-white prose-invert' : ''
              } vazirmatn text-justify`}
              dir="rtl"
            >
              <ReactMarkdown>{message}</ReactMarkdown>
            </div>

            <div
              className={`text-xs mt-1 ${
                isUser ? 'text-blue-100' : 'text-text-secondary'
              }`}
            >
              {formatTime(timestamp)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatMessage;
